module.exports = __webpack_public_path__ + "img/maobi79.1d4a7213.png";